import { render } from "./Sizes.vue?vue&type=template&id=367194ca"
import script from "./Sizes.vue?vue&type=script&lang=ts"
export * from "./Sizes.vue?vue&type=script&lang=ts"
script.render = render

export default script